import React from "react";
import styled from "styled-components";
import { useLanguage } from "../../../LangTranslation/LanguageContext";
import FormikInput from "../../../Formik/FormikInput";
import { connectSocialMedia } from "../../../../DataApi/settings/connectSocialMedia";
import useConfirmationModal from "../../../ConfirmationModal/useConfirmationModal";
import { primaryColor } from "../../../../utilities/colors";

const TableContainer = styled.div`
  margin: 20px !important;
  width: 100%;
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  overflow: auto;
  .table tbody tr td,
  .table thead tr {
    padding: 21px !important;
    font-family: "Inter", sans-serif;
    border-bottom: 0px !important;
    font-weight: 600;
  }

  .table th {
    background-color: #f8f9fa !important;
    padding: 15px !important;
    color: #4e5d78 !important;
    font-family: "Inter", sans-serif;
    font-size: 17px;
  }

  tbody tr:hover {
    background-color: #f4f8ff;
  }
`;
function SocialMedia({
  keyName,
  disableInputs,
  context,
  company_id,
  // activeSocialMediaList,
  form,
  name,
  push,
  replace,
}) {
  const { values } = form;
  const active_SocialMedia_List = values[name] || [];
  const { language, translations } = useLanguage();
  const t = translations[language];

  // console.log(values, "values in the social media");
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();
  // console.log(values, "values");
  const getSocialMediaConnection = async () => {
    var socialMediaResult = await connectSocialMedia();
    socialMediaResult = JSON.parse(socialMediaResult);
    // console.log("socialMediaResult", socialMediaResult);
    if (socialMediaResult?.result?.url) {
      var newPage = window.open(socialMediaResult.result.url, "_blank");
      if (newPage) {
        newPage.focus();
        // console.log("Popup blocked. Please allow popups for this site.");
      }
    } else {
      toggleModal();
      setTitle("Access Error");
      setMetaData({
        primaryButton: "",
        secondaryButton: "Ok",
        dangerouslySetInnerHTML: "Couldn't fetch Connection URL!",
      });
    }
  };

  return (
    <div>
      <ConfirmationModal />
      <h5 style={{ color: "#4E5D78", fontFamily: "Inter" }}>
        {t["Social Media Integration"]}
      </h5>
      {!disableInputs && (
        <button
          type="button"
          onClick={() => getSocialMediaConnection()}
          style={{
            color: primaryColor.primary,
            border: "none",
            marginTop: "10px",
            backgroundColor: "transparent",
            fontWeight: "500",
          }}
        >
          + {t["Connect with Social Media"]}
        </button>
      )}
      {active_SocialMedia_List?.length > 0 ? (
        <TableContainer>
          <table className="table">
            <thead>
              <tr className="heading_row">
                <th>{t["Default"]}</th>
                <th>{t["Social Media"]}</th>
              </tr>
            </thead>
            <tbody>
              {active_SocialMedia_List?.map((media, index) => {
                // console.log(
                //   "activeSocialMediaList in social comp.......",
                //   media,

                //   index
                // );
                return (
                  <tr key={index}>
                    <td className="align-middle">
                      <FormikInput
                        disabled={disableInputs}
                        name={`${name}.${index}.selected`}
                        type="checkbox"
                      />
                    </td>
                    <td>
                      <FormikInput
                        disabled={disableInputs}
                        name={`${name}.${index}.display_name`}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </TableContainer>
      ) : (
        <div className="w-100 text-center  p-3">
          {t["Please Connect Your Social Media From Settings"]}
        </div>
      )}
    </div>
  );
}

export default SocialMedia;
